import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  IAccount,
  IListAccountsSlice,
  LIST_ACCOUNTS_SLICE,
} from "./account.constant";
import {
  onCreateAccount,
  onGetAllAccounts,
  onUpdateAccount,
} from "./accounts.thunk";

const initialState: IListAccountsSlice = {
  accounts: [],
  isGot: false,
};
export const accountsSlice = createSlice({
  name: LIST_ACCOUNTS_SLICE,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      onGetAllAccounts.fulfilled,
      (state, action: PayloadAction<IAccount[]>) => {
        const data = action.payload;
        state.accounts = data;
        state.isGot = true;
      }
    );
    builder.addCase(onGetAllAccounts.rejected, (state) => {
      state.accounts = [];
      state.isGot = false;
    });
    builder.addCase(onUpdateAccount.fulfilled, (state, action) => {
      const updated = action.payload;
      const index = state.accounts.findIndex((c) => c._id === updated._id);
      if (index !== -1) state.accounts[index] = updated;
    });
    builder.addCase(onUpdateAccount.rejected, (state) => {
      console.error("❌ Cập nhật tài khoản thất bại");
    });
    builder.addCase(onCreateAccount.fulfilled, (state, action) => {
      state.accounts.push(action.payload);
    });
    builder.addCase(onCreateAccount.rejected, (state) => {
      console.error("❌ Thêm tài khoản thất bại");
    });
  },
});
export default accountsSlice.reducer;
